<script setup lang="ts">
type Props = {
  optionText: string;
  disabled?: boolean;
};

type Emits = {
  (e: "vote"): void;
};

const { optionText, disabled = false } = defineProps<Props>();

defineEmits<Emits>();
</script>

<template>
  <button
    :disabled="disabled"
    type="button"
    class="w-full rounded-sm border-2 border-kekkle-dark bg-white px-3 py-2 text-left text-sm font-medium text-kekkle-dark shadow-purple-hard-sm transition-all hover:bg-slate-50 active:translate-y-0.5 active:shadow-none disabled:opacity-75 dark:bg-kekkle-dark-light dark:text-slate-200"
    @click="$emit('vote')"
  >
    {{ optionText }}
  </button>
</template>
